import * as types from '../../constants/rmg/SportActionTypes'
import produce from 'immer'
import _ from 'lodash';

const initialState = {
    sports: null,
    loading: false
};

const request = (state) => produce(state, draft => {
    draft.loading = true;
});

const receive = (state, data) => produce(state, draft => {
        draft.sports = data;
        draft.loading = false;
});

export default function reduce (state = initialState, action) {
  switch (action.type) {
    case types.REQUEST:
        return request(state)
    case types.RECEIVE:
        return receive(state, action.data);
    default:
      return state
  }
}
